import { Resource } from "./ResourceType";

export enum NotificationStatus {
    SNOOZED = "snoozed",
    SCHEDULED = "scheduled",
    ACKNOWDELGED = "acknowledged",
    SENT = "sent",
    DISABLED = "disabled",
}

export enum NotificationChannel {
    EMAIL = "email",
    SMS = "SMS",
    EMAIL_AND_SMS = "email_and_sms",
    NONE = "none",
}

export interface Notification {
    id: number;
    resource: Resource;
    status: NotificationStatus;
    notificationDate?: Date;
    creationDate: Date;
    nextNotificationDate?: Date;
    enactedBy?: number;
    enactedReason?: string;
    message: string;
    //this is an ugly fix for data augmentation. This property will always come empty from the server
    order?: any;
}

export interface ResourceNotificationSettings {
    canSnooze?: boolean;
    retryHours?: number;
    notifyDays?: number;
    notifyGroups?: boolean;
    notifyOnMigration?: boolean;
    notify30Days?: boolean;
    notify60Days?: boolean;
    notify90Days?: boolean;
}

export interface UserNotificationPreferences {
    notificationChannel: NotificationChannel;
    phoneNumber: string;
    notificationEmail: string;
}

export interface MostRecentNotificationForResource {
    resource: Resource;
    notification: Notification;
}
